/* eslint-disable */
<template>
  <div id="snackbar">
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :top="true"
      :right="true"
      class="text-white"
      :class=snackbar.customClass
      :timeout="snackbar.timeout"
      :role="snackbar.aria_live"
    >
      <div style="width: 100%" :style="`color: ${snackbar.textColor}`">
        {{ snackbar.text }}
      </div>
      <v-btn
        v-if="(
          snackbar.action
          && snackbar.action_text
        )"
        @click="triggerSnackbarAction(snackbar.action)"
        flat
        text
        :color="snackbar.textColor"
      >
        {{ snackbarActionText }}
      </v-btn>
      <v-btn
        v-if="(
          snackbar.action === null
          || snackbar.action !== 'chrome'
        ) && snackbar.action_text !== 'lti-content-migration-close'"
        @click="snackbar.show = false"
        :color="snackbar.textColor"
        flat
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="toastLoader.toggle"
      color="green"
      :top="true"
      :right="true"
      class="text-white"
      :timeout="0"
    >
      {{ toastLoader.text }}
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-snackbar>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from 'vuex';

import { isFunction } from 'lodash';

export default {
  name: 'snackbar',
  computed: {
    ...mapGetters([
      'snackbar',
      'dialogShow',
      'popoverToggles',
      'instructorData',
    ]),
    ...mapGetters('instructors', [
      'toastLoader',
    ]),
    snackbarActionText() {
      return (this?.snackbar?.action_text === 'lti-content-migration-close') ? 'close' : this?.snackbar?.action_text;
    },
  },
  methods: {
    ...mapActions('instructors', [
      'copyBulb',
    ]),
    triggerSnackbarAction(method) {
      if (isFunction(method)) {
        this.snackbar.show = !this.snackbar.show;
        return method();
      }
      if (method === 'openImportLog') {
        this.dialogShow.dash = true;
        this.popoverToggles.importStatus = true;
      } else if (method === 'chrome') {
        window.open('https://www.google.com/chrome/browser/');
      } else if (method === 'upgrade') {
        window.open(`https://go.playposit.com/pricing?token=${this.instructorData.token}`);
      } else if (method === 'refresh') {
        window.location.reload();
      } else if (method === 'copyBulb') {
        this.copyBulb({
          name: _.get(this, 'snackbar.actionData.newBulbName', 'Bulb Copy'),
          id: _.get(this, 'snackbar.actionData.bulbId', -1),
          fullCopy: _.get(this, 'snackbar.actionData.fullCopy', true),
          lti: _.get(this, 'snackbar.actionData.lti', false),
          edit: _.get(this, 'snackbar.actionData.edit', false),
          refreshData: _.get(this, 'snackbar.actionData.refreshData', true),
          forceThrough: _.get(this, 'snackbar.actionData.forceThrough', true),
          isCopyingUnrestricted: _.get(this, 'snackbar.actionData.isCopyingUnrestricted', false),
        });
        this.snackbar.show = false;
        this.snackbar.action = null;
        this.snackbar.actionData = null;
        this.snackbar.actionText = null;
      } else if (method === 'groupsPeerReviewPlayPosit') {
        window.open(
          'https://knowledge.playposit.com/article/291-peer-review-for-instructors-using-playposit-groups#update-groups'
        );
      } else if (method === 'groupsPeerReviewCanvas') {
        window.open('https://knowledge.playposit.com/article/224-peer-review-instructors#');
      }
    },
  },
};
</script>

<style scoped></style>
